//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { getVerifyRecords } from '@/api/distributionAlliance';
var STATUS = {
  PENDING_CONFIRM: '待确认',
  VERIFIED: '已核销',
  PART_REFUND: '部分退款',
  REFUNDED: '已退款',
  CANCELLED: '已撤销',
  EXPIRED: '已过期'
};
export default {
  name: 'AllianceVerifyRecords',
  data: function data() {
    return {
      STATUS: STATUS,
      loading: false,
      list: [],
      total: 0,
      dateRange: [],
      query: {
        merchantId: null,
        uid: null,
        type: '',
        status: '',
        keyword: '',
        page: 1,
        size: 20
      }
    };
  },
  created: function created() {
    this.loadList(1);
  },
  methods: {
    statusText: function statusText(s) {
      return STATUS[s] || s || '-';
    },
    statusTagType: function statusTagType(s) {
      return {
        PENDING_CONFIRM: 'warning',
        VERIFIED: 'success',
        PART_REFUND: 'warning',
        REFUNDED: 'danger',
        CANCELLED: 'danger',
        EXPIRED: 'info'
      }[s] || 'info';
    },
    // 后端一律用分存金额，不用浮点。这里只是展示，除以 100 即可
    yuan: function yuan(fen) {
      return '￥' + (Number(fen || 0) / 100).toFixed(2);
    },
    loadList: function loadList(page) {
      var _this = this;
      if (page) this.query.page = page;
      var params = {};
      Object.keys(this.query).forEach(function (key) {
        var value = _this.query[key];
        if (value !== '' && value !== null && value !== undefined && !Number.isNaN(value)) {
          params[key] = value;
        }
      });
      if (this.dateRange && this.dateRange.length === 2) {
        params.startTime = this.dateRange[0];
        params.endTime = this.dateRange[1];
      }
      this.loading = true;
      getVerifyRecords(params).then(function (res) {
        _this.list = res && res.list || [];
        _this.total = res && res.total || 0;
      }).finally(function () {
        _this.loading = false;
      });
    },
    onSizeChange: function onSizeChange(size) {
      this.query.size = size;
      this.loadList(1);
    },
    reset: function reset() {
      this.dateRange = [];
      this.query = {
        merchantId: null,
        uid: null,
        type: '',
        status: '',
        keyword: '',
        page: 1,
        size: 20
      };
      this.loadList(1);
    }
  }
};